export const capitalizeFirstLetter = (str) => {
	if (typeof str !== 'string' || str.length === 0) {
		return '';
	}
	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const TELEFONO_REGEX = /^\+?\d{8,15}$/;
const MAX_DIGITOS_TELEFONO = 15;

export const normalizarTelefonoInput = (valor = '') => {
	const valorString = String(valor);
	const incluyeMasInicial = valorString.startsWith('+');
	const soloDigitos = valorString.replace(/\D/g, '').slice(0, MAX_DIGITOS_TELEFONO);
	return incluyeMasInicial ? `+${soloDigitos}` : soloDigitos;
};

export const esTelefonoValido = (telefono = '') => {
	return TELEFONO_REGEX.test(String(telefono).trim());
};

export const esSoloNumerico = (cadena) => {
	return esTelefonoValido(cadena);
};

const TELEFONO_CELULAR_URUGUAY_LOCAL_CON_CERO_REGEX = /^09\d{7}$/;
const TELEFONO_CELULAR_URUGUAY_LOCAL_REGEX = /^9\d{7}$/;
const TELEFONO_CELULAR_URUGUAY_INTERNACIONAL_REGEX = /^5989\d{7}$/;

const obtenerSoloDigitos = (telefono = '') => String(telefono).replace(/\D/g, '');

export const esCelularUruguay = (telefono = '') => {
	const telefonoSoloDigitos = obtenerSoloDigitos(telefono);
	return (
		TELEFONO_CELULAR_URUGUAY_LOCAL_CON_CERO_REGEX.test(telefonoSoloDigitos) ||
		TELEFONO_CELULAR_URUGUAY_LOCAL_REGEX.test(telefonoSoloDigitos) ||
		TELEFONO_CELULAR_URUGUAY_INTERNACIONAL_REGEX.test(telefonoSoloDigitos)
	);
};

export const obtenerTelefonoWhatsAppUruguay = (telefono = '') => {
	const telefonoSoloDigitos = obtenerSoloDigitos(telefono);

	if (TELEFONO_CELULAR_URUGUAY_INTERNACIONAL_REGEX.test(telefonoSoloDigitos)) {
		return telefonoSoloDigitos;
	}

	if (TELEFONO_CELULAR_URUGUAY_LOCAL_CON_CERO_REGEX.test(telefonoSoloDigitos)) {
		return `598${telefonoSoloDigitos.slice(1)}`;
	}

	if (TELEFONO_CELULAR_URUGUAY_LOCAL_REGEX.test(telefonoSoloDigitos)) {
		return `598${telefonoSoloDigitos}`;
	}

	return null;
};
